import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { useEffect } from 'react';
import usePlanStore from '../../../../../../store/planStore';
import { Countries } from '../../../../../../shared/enums';
import Digital from './Digital/Digital';
import Offline from './Offline/Offline';
import OneReach from './OneReach/OneReach';
import CountryPlanSummary from './CountryPlanSummary/CountryPlanSummary';
import useTouchpoints from '../hooks/useTouchpoints';
import { Touchpoints } from '../../enums';
import prepareAvailableTouchpoints from '../utils/prepareAvailableTouchpoints';

function NestedCountryTabs() {
  const {
    selectedCountryISOCode,
    activeNestedTab,
    setActiveNestedTab,
    savedCountryForms,
    countryForms,
    selectedCountry,
  } = usePlanStore();

  useEffect(() => {
    if (
      selectedCountryISOCode !== Countries.POLAND &&
      activeNestedTab === 'oneReach'
    ) {
      setActiveNestedTab('digital');
    }
  }, [activeNestedTab, selectedCountryISOCode]);

  const {
    data: availableTouchpoints,
    isFetching: isFetchingAvailableTouchpoints,
  } = useTouchpoints();

  const uniqueTouchpoints = prepareAvailableTouchpoints(availableTouchpoints);

  return (
    <Box sx={{ backgroundColor: 'common.white', borderRadius: '5px' }}>
      <TabContext value={activeNestedTab}>
        <Tabs
          value={activeNestedTab}
          onChange={(e, val) => setActiveNestedTab(val)}
          sx={{ borderBottom: '1px solid', borderColor: 'gray.chrome' }}
        >
          <Tab label="Digital" value="digital" />
          <Tab
            label="Offline"
            value="offline"
            disabled={
              !uniqueTouchpoints.includes(Touchpoints.tv) &&
              !uniqueTouchpoints.includes(Touchpoints.ooh)
            }
          />
          <Tab
            label="One Reach"
            value="oneReach"
            disabled={
              selectedCountryISOCode !== Countries.POLAND ||
              (!savedCountryForms[selectedCountry!]?.calculatedBudget?.length &&
                !countryForms[selectedCountry!].offline?.tv?.offlineBudget)
            }
          />
          <Tab label="Country Summary" value="planSummary" />
        </Tabs>
        <TabPanel value="digital" sx={{ p: 0 }}>
          <Digital
            availableTouchpoints={availableTouchpoints}
            isFetchingAvailableTouchpoints={isFetchingAvailableTouchpoints}
          />
        </TabPanel>
        <TabPanel value="offline" sx={{ p: 0 }}>
          <Offline availableTouchpoints={availableTouchpoints} />
        </TabPanel>
        <TabPanel value="oneReach" sx={{ p: 0 }}>
          <OneReach availableTouchpoints={availableTouchpoints} />
        </TabPanel>
        <TabPanel value="planSummary" sx={{ p: 0 }}>
          <CountryPlanSummary />
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default NestedCountryTabs;
